var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJob = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "briefcase"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3333 18.9583H6.66659C2.81659 18.9583 2.09992 17.1667 1.91659 15.425L1.29159 8.75C1.19992 7.875 1.17492 6.58334 2.04159 5.61667C2.79159 4.78334 4.03325 4.38334 5.83325 4.38334H14.1666C15.9749 4.38334 17.2166 4.79167 17.9583 5.61667C18.8249 6.58334 18.7999 7.875 18.7083 8.75834L18.0833 15.4167C17.8999 17.1667 17.1833 18.9583 13.3333 18.9583ZM5.83325 5.625C4.42492 5.625 3.45825 5.9 2.96659 6.45C2.55825 6.9 2.42492 7.59167 2.53325 8.625L3.15825 15.3C3.29992 16.6167 3.65825 17.7083 6.66659 17.7083H13.3333C16.3333 17.7083 16.6999 16.6167 16.8416 15.2917L17.4666 8.63334C17.5749 7.59167 17.4416 6.9 17.0333 6.45C16.5416 5.9 15.5749 5.625 14.1666 5.625H5.83325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.3333 5.62501C12.9916 5.62501 12.7083 5.34168 12.7083 5.00001V4.33334C12.7083 2.85001 12.7083 2.29168 10.6666 2.29168H9.3333C7.29163 2.29168 7.29163 2.85001 7.29163 4.33334V5.00001C7.29163 5.34168 7.0083 5.62501 6.66663 5.62501C6.32496 5.62501 6.04163 5.34168 6.04163 5.00001V4.33334C6.04163 2.86668 6.04163 1.04168 9.3333 1.04168H10.6666C13.9583 1.04168 13.9583 2.86668 13.9583 4.33334V5.00001C13.9583 5.34168 13.675 5.62501 13.3333 5.62501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.99996 13.9583C7.7083 13.9583 7.7083 12.5417 7.7083 11.6917V10.8333C7.7083 9.65834 7.99163 9.37501 9.16663 9.37501H10.8333C12.0083 9.37501 12.2916 9.65834 12.2916 10.8333V11.6667C12.2916 12.5333 12.2916 13.9583 9.99996 13.9583ZM8.9583 10.625C8.9583 10.6917 8.9583 10.7667 8.9583 10.8333V11.6917C8.9583 12.55 8.9583 12.7083 9.99996 12.7083C11.0416 12.7083 11.0416 12.575 11.0416 11.6833V10.8333C11.0416 10.7667 11.0416 10.6917 11.0416 10.625C10.975 10.625 10.9 10.625 10.8333 10.625H9.16663C9.09996 10.625 9.02496 10.625 8.9583 10.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.6666 12.3084C11.3583 12.3084 11.0833 12.075 11.05 11.7584C11.0083 11.4167 11.25 11.1 11.5916 11.0584C13.7916 10.7834 15.9 9.95002 17.675 8.65835C17.95 8.45002 18.3416 8.51669 18.55 8.80002C18.75 9.07502 18.6916 9.46669 18.4083 9.67502C16.4583 11.0917 14.1583 12 11.7416 12.3084C11.7166 12.3084 11.6916 12.3084 11.6666 12.3084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.33326 12.3167C8.30826 12.3167 8.28326 12.3167 8.25826 12.3167C5.97493 12.0583 3.74993 11.225 1.82493 9.90835C1.54159 9.71668 1.46659 9.32502 1.65826 9.04168C1.84993 8.75835 2.24159 8.68335 2.52492 8.87502C4.28326 10.075 6.30826 10.8333 8.39159 11.075C8.73326 11.1167 8.98326 11.425 8.94159 11.7667C8.91659 12.0833 8.64993 12.3167 8.33326 12.3167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    opacity: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJob);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/job.699c61b4f3b1ceb1c3e1d5e8934f07f5.svg";